import { mountModule } from '@websky/core/src/__fsd__/shared/lib/mount-module';
import { enableSentry } from '@websky/core/src/utils';
import { Config, mergeConfig } from '@websky/core/src/context';
import { withConfig } from '@websky/core/src/config-hoc';
import { config as defaultConfig } from '../../config';

enableSentry();

import SocialAuthCallback from './Component';

export const init = (mount: HTMLElement, config: Config): (() => void) => {
	const Component = withConfig(SocialAuthCallback, mergeConfig(defaultConfig, config));

	return mountModule(Component, mount);
};
